/**
 * Divisas soportadas por la plataforma. Vive en shared porque tanto el backend
 * (validación al crear/importar expedientes) como el frontend (validación previa
 * de la importadora) necesitan la misma lista.
 */
const SUPPORTED_CURRENCIES = {
  EUR: { symbol: '€', name: 'Euro' },
  USD: { symbol: '$', name: 'US Dollar' },
  GBP: { symbol: '£', name: 'British Pound' },
  JPY: { symbol: '¥', name: 'Japanese Yen' },
  CHF: { symbol: 'CHF', name: 'Swiss Franc' },
  AUD: { symbol: 'A$', name: 'Australian Dollar' },
  CAD: { symbol: 'C$', name: 'Canadian Dollar' },
  CNY: { symbol: '¥', name: 'Chinese Yuan' },
};

const CURRENCY_CODES = Object.keys(SUPPORTED_CURRENCIES);

const isValidCurrency = currency =>
  Object.prototype.hasOwnProperty.call(SUPPORTED_CURRENCIES, String(currency ?? '').toUpperCase());

module.exports = { SUPPORTED_CURRENCIES, CURRENCY_CODES, isValidCurrency };
